import React from "react";
import { ShortcutKeys } from "../../atoms/ShortcutKeys";
import { SOON_TOOLTIP, SoonBadge } from "../../atoms/SoonBadge";
import { Icon, Label, Menu, Row } from "./HelpMenu.styles";
import type { HelpMenuProps } from "./HelpMenu.types";

/** Arrow keys move between rows. */
const onMenuKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
  const rows = Array.from(event.currentTarget.querySelectorAll<HTMLElement>('[role="menuitem"]'));
  const at = rows.indexOf(document.activeElement as HTMLElement);
  const next = event.key === "ArrowDown" ? (at + 1) % rows.length : (at - 1 + rows.length) % rows.length;
  event.preventDefault();
  rows[next]?.focus();
};

/** A mailto link opens the mail app, not a new tab. */
const isMail = (href: string) => href.startsWith("mailto:");

export const HelpMenu: React.FC<HelpMenuProps> = ({ items, label, soonLabel, onSelect, mac, className }) => (
  <Menu role="menu" aria-label={label} className={className} onKeyDown={onMenuKeyDown}>
    {items.map((item) => {
      const disabled = Boolean(item.soon || item.disabledReason);
      const title = item.soon ? SOON_TOOLTIP : item.disabledReason;
      const common = {
        role: "menuitem" as const,
        title,
        "aria-disabled": disabled ? ("true" as const) : undefined,
      };
      const content = (
        <>
          <Icon aria-hidden="true" $tone={item.iconTone}>{item.icon}</Icon>
          <Label>{item.label}</Label>
          {item.soon ? <SoonBadge label={soonLabel} /> : null}
          {!disabled && item.chords?.length ? <ShortcutKeys chords={item.chords} mac={mac} /> : null}
        </>
      );
      if (item.href && !disabled) {
        return (
          <Row key={item.id} as="a" href={item.href} {...(isMail(item.href) ? {} : { target: "_blank", rel: "noreferrer" })} {...common} onClick={() => onSelect(item.id)}>
            {content}
          </Row>
        );
      }
      return (
        <Row key={item.id} type="button" {...common} onClick={disabled ? undefined : () => onSelect(item.id)}>
          {content}
        </Row>
      );
    })}
  </Menu>
);

export default HelpMenu;
